export default __webpack_public_path__ + "static/media/icon-navigate.6a99a010.svg";